export const INSIGHT_CATEGORY_ALL = 'all' as const

export type InsightCategoryFilter = string | typeof INSIGHT_CATEGORY_ALL

export interface IInsightEntity {
  id: string
  reportName: string
  category: string
  contentCoverage: string
  producer: string
  releaseDate: string
  downloadUrl: string
}

export interface IUseMemberInsightsReturn {
  isLoading: boolean
  isError: boolean
  isEmpty: boolean
  searchTerm: string
  categoryFilter: InsightCategoryFilter
  categoryOptions: string[]
  isCategoriesLoading: boolean
  isCategoriesError: boolean
  producerFilter: string
  producerOptions: string[]
  currentPage: number
  totalPages: number
  pageItems: IInsightEntity[]
  totalCount: number
  selectedInsight: IInsightEntity | null
  selectedInsightBlobUrl: string | null
  setSearchTerm: (value: string) => void
  setCategoryFilter: (value: InsightCategoryFilter) => void
  setProducerFilter: (value: string) => void
  setCurrentPage: (page: number) => void
  openInsightPreview: (insight: IInsightEntity) => void
  closeInsightPreview: () => void
}
